import axios from './_nestAxios'

export const actualizarRol = (_id, data) => axios.put(`/roles/${_id}`, data)
export const eliminarRol = _id => axios.delete(`/roles/${_id}`)
export const getRol = _id => axios.get(`/roles/${_id}`)
export const getRoles_Select = () => axios.get('/roles', { params: { tipoConsulta: 'select' } })
export const nuevoRol = data => axios.post('/roles', data)
export const duplicarRol = data => axios.post(`/roles/duplicar`, data)
